var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgHeartMonitor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    style: {
      fill: "rgb(233,244,246)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.965926,-0.258819,0.258819,0.965926,-1.34847,1.75736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.081,6.156L6.695,5.388L5.614,7.547C5.559,7.665 5.437,7.738 5.305,7.738C5.173,7.738 5.051,7.665 4.996,7.547L4.394,6.348L2.524,6.348L2.524,8.085C2.524,8.468 2.837,8.781 3.219,8.781L8.781,8.781C9.163,8.781 9.476,8.468 9.476,8.085L9.476,6.348L7.39,6.348C7.258,6.348 7.137,6.275 7.081,6.156ZM8.781,3.219L3.219,3.219C2.837,3.219 2.524,3.532 2.524,3.915L2.524,5.652L4.61,5.652C4.742,5.652 4.863,5.725 4.919,5.844L5.305,6.612L6.386,4.453C6.504,4.217 6.89,4.217 7.008,4.453L7.606,5.652L9.476,5.652L9.476,3.915C9.476,3.532 9.163,3.219 8.781,3.219Z",
    style: {
      fill: "rgb(0,79,112)",
      fillRule: "nonzero"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHeartMonitor);
export default __webpack_public_path__ + "static/media/bg-heart-monitor.f2e4ff2e72537530922fc2bca5e2e44e.svg";
export { ForwardRef as ReactComponent };